export type ButtonType = "button" | "link" | "sendgeo" | "sendcontact" | "app";

interface IParseButton {
	buttonType: ButtonType;
	buttonName: string;
	buttonData: string;
}

// шаблон
const buttonRegexpPattern = /{(button|link|sendgeo|sendcontact|app):.+?(=.+?)?}(\n)?/g;

// разбить шаблоны кнопок на блоки
const splitButtonTemplatesIntoBlocks = (text: string): string[][] => {
	const buttonMatches = `${text}`.match(buttonRegexpPattern); // text к строке приравнен из-за ошибки бэка, когда фраза непонятного содержания, вместо строки
	// если есть совпадения по шаблону кнопок
	if (buttonMatches) {
		const data: string[][] = [[]];
		// разбиваем на массивы по переносу строк
		buttonMatches.forEach((buttonCode) => {
			data[data.length - 1].push(buttonCode);
			if (buttonCode.includes("\n")) data.push([]);
		});
		return data;
	} else {
		return [];
	}
};

// парсинг кнопки из фразы
const parsingButtonInMessage = (text: string): IParseButton => {
	const startIndexName = text.indexOf(":");
	const endIndexName = text.indexOf(text.includes("=") ? "=" : "}");
	const buttonType = text.slice(1, startIndexName) as ButtonType;
	const buttonName = text.slice(startIndexName + 1, endIndexName);
	const buttonData = text.slice(endIndexName + 1, text.includes("\n") ? -2 : -1);
	return { buttonType, buttonName, buttonData };
};

export { buttonRegexpPattern, splitButtonTemplatesIntoBlocks, parsingButtonInMessage };
